<admin-panel-configurable [title]="'Data Source'">
  <admin-panel-empty>
    <div class="row">
      <div class="col-6">
        <div class="mb-3">
          <span class="">source</span>
          <div class="text-dark message-content border" style="border-style: dashed !important;">
            {{ this.input!.source! | json}}
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="mb-3">
          <span class="">transformer</span>
          <div class="text-dark message-content border" style="border-style: dashed !important;">
            {{ this.input!.transformer! | json}}
          </div>
        </div>
      </div>
    </div>
  </admin-panel-empty>

  <admin-table-standard [items]="inputConfig">
    <ng-template #header>
      <th class="col-4">{{'common.tables.name' | translate }}</th>
      <th class="col-4">{{'common.tables.type' | translate }}</th>
      <th class="col-4">{{'common.tables.value' | translate }}</th>
    </ng-template>
    <ng-template #first let-item>
      <td class="align-middle">{{ item.name }}</td>
      <td class="align-middle">{{ item.type }}</td>
      <td class="align-middle">{{ item.value | json }}</td>
    </ng-template>
  </admin-table-standard>
</admin-panel-configurable>

<div class="pt-3"></div>

<admin-panel-configurable *ngIf="hasConfig(mappingConfig)" [title]="'Data Mapping'">
  <admin-table-standard [items]="mappingConfig">
    <ng-template #header>
      <th class="col-4">{{'common.tables.name' | translate }}</th>
      <th class="col-4">{{'common.tables.mapping' | translate }}</th>
      <th class="col-4">{{'common.tables.value' | translate }}</th>
    </ng-template>
    <ng-template #first let-item>
      <td class="align-middle">{{ item.parameter }}</td>
      <td class="align-middle">{{ item.mapping }}</td>
      <td class="align-middle">{{ item.value | json }}</td>
    </ng-template>
  </admin-table-standard>
</admin-panel-configurable>
